/*
 * distrito-variant-fix.js
 * Hace que al elegir un COLOR, las demás opciones (almacenamiento, condición)
 * se ajusten automáticamente a una variante DISPONIBLE de ese color.
 * Así siempre puedes volver a cualquier color sin que la tienda "rebote".
 *
 * El color trae en data-variant-options la lista de valores (por posición de
 * opción) de su primera variante disponible. Sincronizamos esos valores en
 * fase de captura, antes de que el componente <variant-selects> lea la selección.
 */
(function () {
  'use strict';

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;

      var opts = input.getAttribute('data-variant-options');
      if (!opts) return; // solo los inputs de Color lo tienen

      var vs = input.closest('variant-selects');
      if (!vs) return;

      var values = opts.split('|');
      var groups = vs.querySelectorAll('fieldset, .product-form__input--dropdown');

      groups.forEach(function (group, i) {
        var want = values[i];
        if (want == null) return;

        var radios = group.querySelectorAll('input[type="radio"]');
        if (radios.length) {
          radios.forEach(function (r) {
            r.checked = r.value === want;
          });
        } else {
          var sel = group.querySelector('select');
          if (sel) {
            Array.prototype.forEach.call(sel.options, function (o) {
              if (o.value === want) {
                o.selected = true;
                o.setAttribute('selected', 'selected');
              } else {
                o.removeAttribute('selected');
              }
            });
          }
        }
      });
    },
    true // captura: se ejecuta antes que el listener del componente
  );
})();
